(() => {
  const reviewRootSelector = '#ddReview';
  const pluginToggleSelector = "[class*='CommonWidget_displayText']";

  function normalizeReviewCards() {
    const reviewRoot = document.querySelector(reviewRootSelector);
    if (!reviewRoot) return;

    reviewRoot.querySelectorAll('.he-review-toggle').forEach((button) => {
      button.remove();
    });

    reviewRoot.querySelectorAll('.he-review-clamped, .he-review-expanded').forEach((content) => {
      content.classList.remove('he-review-clamped', 'he-review-expanded');
      delete content.dataset.heReviewReady;
    });

    reviewRoot.querySelectorAll(pluginToggleSelector).forEach((toggle) => {
      if (/\[\s*\.{3}\s*\]/.test(toggle.textContent || '')) {
        toggle.textContent = 'Read more';
        toggle.setAttribute('role', 'button');
        toggle.setAttribute('tabindex', '0');
        toggle.setAttribute('aria-label', 'Read the full review');

        if (toggle.dataset.heReviewToggleReady !== 'true') {
          toggle.dataset.heReviewToggleReady = 'true';
          toggle.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              toggle.click();
            }
          });
        }
      }
    });
  }

  let scheduled = false;

  function scheduleNormalization() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      normalizeReviewCards();
    });
  }

  const observer = new MutationObserver(scheduleNormalization);

  function initialize() {
    normalizeReviewCards();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();

(() => {
  const fitGuideData = document.querySelector('[data-he-fit-guide]');
  const fitGuideUrl = fitGuideData?.dataset.imageUrl || '';
  const fitGuideAlt = fitGuideData?.dataset.imageAlt || 'Skiwear fit guide';
  const shouldShowFits = Boolean(fitGuideUrl);

  function setActiveFitTab(sizePanel, fitsPanel, sizeButton, fitsButton, activeTab) {
    const showFits = activeTab === 'fits';

    sizePanel.hidden = showFits;
    fitsPanel.hidden = !showFits;
    sizeButton.classList.toggle('active', !showFits);
    fitsButton.classList.toggle('active', showFits);
    sizeButton.setAttribute('aria-selected', String(!showFits));
    fitsButton.setAttribute('aria-selected', String(showFits));
    sizeButton.tabIndex = showFits ? -1 : 0;
    fitsButton.tabIndex = showFits ? 0 : -1;
  }

  function enhanceSizeChartWithFits() {
    if (!shouldShowFits || !fitGuideUrl) return;

    document
      .querySelectorAll('.sc-storefront-sizechart-scope .nx-sizechart-preview-content')
      .forEach((content) => {
        if (content.dataset.heFitsReady === 'true') return;

        const sizePanel = content.querySelector('.nx-sizechart-preview-panel');
        if (!sizePanel) return;

        content.dataset.heFitsReady = 'true';

        const tabs = document.createElement('div');
        tabs.className = 'he-sizechart-tabs';
        tabs.setAttribute('role', 'tablist');
        tabs.setAttribute('aria-label', 'Size guide sections');

        const sizeButton = document.createElement('button');
        sizeButton.type = 'button';
        sizeButton.className = 'he-sizechart-tab active';
        sizeButton.textContent = 'Size Chart';
        sizeButton.setAttribute('role', 'tab');
        sizeButton.setAttribute('aria-selected', 'true');
        sizeButton.setAttribute('aria-controls', 'he-sizechart-size-panel');
        sizeButton.id = 'he-sizechart-size-tab';

        const fitsButton = document.createElement('button');
        fitsButton.type = 'button';
        fitsButton.className = 'he-sizechart-tab';
        fitsButton.textContent = 'Fits';
        fitsButton.setAttribute('role', 'tab');
        fitsButton.setAttribute('aria-selected', 'false');
        fitsButton.setAttribute('aria-controls', 'he-sizechart-fits-panel');
        fitsButton.id = 'he-sizechart-fits-tab';
        fitsButton.tabIndex = -1;

        const fitsPanel = document.createElement('div');
        fitsPanel.className = 'he-sizechart-fits-panel';
        fitsPanel.id = 'he-sizechart-fits-panel';
        fitsPanel.setAttribute('role', 'tabpanel');
        fitsPanel.setAttribute('aria-labelledby', 'he-sizechart-fits-tab');
        fitsPanel.hidden = true;

        const image = document.createElement('img');
        image.src = fitGuideUrl;
        image.alt = fitGuideAlt;
        image.loading = 'eager';
        fitsPanel.appendChild(image);

        sizePanel.id = 'he-sizechart-size-panel';
        sizePanel.setAttribute('role', 'tabpanel');
        sizePanel.setAttribute('aria-labelledby', 'he-sizechart-size-tab');

        sizeButton.addEventListener('click', () => {
          setActiveFitTab(sizePanel, fitsPanel, sizeButton, fitsButton, 'size');
        });

        fitsButton.addEventListener('click', () => {
          setActiveFitTab(sizePanel, fitsPanel, sizeButton, fitsButton, 'fits');
        });

        tabs.append(sizeButton, fitsButton);
        content.insertBefore(tabs, sizePanel);
        content.appendChild(fitsPanel);
      });
  }

  let fitsScheduled = false;

  function scheduleFitsEnhancement() {
    if (fitsScheduled) return;
    fitsScheduled = true;

    requestAnimationFrame(() => {
      fitsScheduled = false;
      enhanceSizeChartWithFits();
    });
  }

  const fitsObserver = new MutationObserver(scheduleFitsEnhancement);

  function initializeFitsEnhancement() {
    enhanceSizeChartWithFits();
    fitsObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFitsEnhancement, { once: true });
  } else {
    initializeFitsEnhancement();
  }
})();

(() => {
  const circledNumbers = ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'];

  function numberSizeChartHeaders() {
    document
      .querySelectorAll('.sc-storefront-sizechart-scope table.nx-preview-table-el thead tr')
      .forEach((row) => {
        const headers = Array.from(row.querySelectorAll('th'));

        if (headers.length < 2 || headers[0].textContent.trim().toLowerCase() !== 'size') {
          return;
        }

        headers.slice(1).forEach((header, index) => {
          if (header.dataset.heSizeHeaderNumbered === 'true') return;

          const label = header.textContent.trim().replace(/^[①②③④⑤⑥⑦⑧⑨⑩]\s*/, '');
          const number = circledNumbers[index];

          if (!number || !label) return;

          header.dataset.heSizeHeaderNumbered = 'true';
          header.textContent = `${number} ${label}`;
        });
      });
  }

  let sizeChartScheduled = false;

  function scheduleSizeChartNumbering() {
    if (sizeChartScheduled) return;
    sizeChartScheduled = true;

    requestAnimationFrame(() => {
      sizeChartScheduled = false;
      numberSizeChartHeaders();
    });
  }

  const sizeChartObserver = new MutationObserver(scheduleSizeChartNumbering);

  function initializeSizeChartNumbering() {
    numberSizeChartHeaders();
    sizeChartObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSizeChartNumbering, { once: true });
  } else {
    initializeSizeChartNumbering();
  }
})();


(() => {
  const styleId = 'he-review-single-image-preview';

  if (document.getElementById(styleId)) return;

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    #ddReview .reCell [class*='CommonWidget_darksmallImgBox'] {
      display: block !important;
    }

    #ddReview .reCell [class*='CommonWidget_darksmallImgBox'] > :first-child {
      width: 100% !important;
      height: 100% !important;
    }

    #ddReview .reCell [class*='CommonWidget_darksmallImgBox'] > [class*='CommonWidget_darkleftImgBox'] {
      display: none !important;
    }

    #ddReview .reCell [class*='CommonWidget_darksmallImgBox'] > :first-child > img {
      display: block !important;
      width: 100% !important;
      height: 100% !important;
      max-height: none !important;
      object-fit: cover !important;
      border-radius: 8px 8px 0 0 !important;
    }
  `;

  document.head.appendChild(style);
})();